import { apiRoutes } from "../../config";
import { api } from "../../utils/lib/api";

/**
 * Generar reporte de productos ML con columnas dinámicas para linkedTo
 * @param {string} enterpriseId - ID de la empresa
 * @param {string} fileType - Tipo de archivo (xlsx, csv)
 * @param {object} filter - Filtros adicionales (opcional)
 */
export const getMlProductsReport = async (enterpriseId, fileType, filter = {}) => {
  try {
    const url = new URL(`${apiRoutes.ml.report}/${enterpriseId}/products/${fileType}`);
    
    if (Object.keys(filter).length > 0) {
      url.searchParams.append('filter', JSON.stringify(filter));
    }
    
    return await api.get(url.toString());
  } catch (error) {
    console.error('Error al generar reporte de productos ML:', error);
    throw error;
  }
};


